import { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { BsThreeDotsVertical } from "react-icons/bs";
import canna42 from "../assets/imgPlaceholder.png";
import styles from "../styles/productMenuListItem.module.css";

const BusinessExperienceListItem = ({
  experience,

  actions,
}: {
  experience: any;

  actions: Actions & {
    duplicate?: Function;
  };
}) => {
  const [imageSrc, setImageSrc] = useState<string>(experience.imageUrl || canna42);

  // Update imageSrc when experience prop changes
  useEffect(() => {
    setImageSrc(experience.imageUrl || canna42);
  }, [experience]);

  // Function to handle the image error
  const handleImageError = () => {
    setImageSrc(canna42); // Set the source to the default image on error
  };

  // Function to convert date to readable format
  const toReadableDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      timeZone: "UTC",
    });
  };

  const readableStartDate = toReadableDate(experience.eventBeginDate);
  const readableEndDate = toReadableDate(experience.eventEndDate);

  return (
    <tr className={styles.productListItem}>
      <td>
        <img
          src={imageSrc}
          alt=""
          style={{
            width: "50px",
            height: "50px",
            marginRight: "10px",
            borderRadius: 10,
            border: "1px solid #ccc",
          }}
          onError={handleImageError}
        />
        <span>{experience.headline}</span>
      </td>
      <td>{experience.locationName}</td>
      {/* <td>{FormatInstance.renderReadableExpirationTimestamp(product.createdAt)}</td> */}
      <td>{readableStartDate === readableEndDate ? readableStartDate : `${readableStartDate}-${readableEndDate}`}</td>
      <td>
        {experience.startTime}-{experience.endTime}
      </td>
      <td className={styles.actionsCell}>
        <Dropdown className="justify-content-center">
          {" "}
          {/* Change alignRight to align="end" */}
          <Dropdown.Toggle as={BsThreeDotsVertical} id={`dropdown-${experience.id}`} />
          <Dropdown.Menu className="flex-start-end">
            <>
              {actions.edit && ( // Ensure edit action is defined
                <Dropdown.Item onClick={() => actions.edit && actions.edit(experience)}>Edit</Dropdown.Item>
              )}
            </>
            <>
              {actions.duplicate && ( // Ensure duplicate action is defined
                <Dropdown.Item onClick={() => actions.duplicate && actions.duplicate(experience)}>Copy</Dropdown.Item>
              )}
            </>
          </Dropdown.Menu>
        </Dropdown>
      </td>
    </tr>
  );
};

export default BusinessExperienceListItem;
